import { render, staticRenderFns } from "./DialogoBuscarVeiculos.vue?vue&type=template&id=ca8ed826&scoped=true&"
import script from "./DialogoBuscarVeiculos.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarVeiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8ed826",
  null
  
)

export default component.exports